/* eslint-disable @typescript-eslint/no-explicit-any */

import {MutationCache, QueryClient} from '@tanstack/react-query';
import {handleError} from 'shared';

import type {
  UseQueryOptions,
  UseMutationOptions,
  DefaultOptions,
  UseSuspenseQueryOptions,
} from '@tanstack/react-query';
import type {HTTPError} from 'ky';

const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: import.meta.env.PROD,
    networkMode: 'online',
    staleTime: 1000 * 60,
    throwOnError: true,
  },
  mutations: {
    throwOnError: false,
  },
};

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError(error) {
      handleError(error);
    },
  }),
  defaultOptions: queryConfig,
});

export type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<
  ReturnType<FnType>
>;

export type QueryConfig<QueryFnType extends (...args: any) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  'queryKey' | 'queryFn'
>;
export type QueryConfig2<QueryFnType extends (...args: any) => any> =
  UseSuspenseQueryOptions<ExtractFnReturnType<QueryFnType>>;

export type MutationConfig<MutationFnType extends (...args: any) => any> =
  UseMutationOptions<
    ExtractFnReturnType<MutationFnType>,
    HTTPError,
    Parameters<MutationFnType>[0]
  >;
